import { useEffect, useRef, useState } from "react";
import { useInView, animate } from "framer-motion";
import Reveal from "./Reveal";
import { api } from "../lib/api";

function useCountUp(target) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [val, setVal] = useState(0);
  useEffect(() => {
    if (!inView || !target) return;
    const controls = animate(0, target, {
      duration: 1.9,
      ease: [0.22, 1, 0.36, 1],
      onUpdate: (v) => setVal(Math.floor(v)),
    });
    return () => controls.stop();
  }, [inView, target]);
  return { ref, val };
}

export default function SovereignCounter() {
  const [total, setTotal] = useState(null);

  useEffect(() => {
    api
      .get("/pypi/stats")
      .then((r) =>
        setTotal(r.data.downloads_total ?? r.data.downloads_month ?? 0)
      )
      .catch(() => setTotal(0));
  }, []);

  const { ref, val } = useCountUp(total ?? 0);

  return (
    <section
      className="border-t border-white/5 py-24 md:py-28"
      data-testid="sovereign-counter"
    >
      <div className="container-x">
        <Reveal>
          <p className="overline text-center">The sovereign scoreboard</p>
          <h2 className="mx-auto mt-4 max-w-3xl text-center font-display text-3xl font-light leading-tight tracking-tight text-paper md:text-[2.6rem]">
            Others count the memories in their cloud. We count the ones we'll
            never see.
          </h2>
        </Reveal>

        <div ref={ref} className="mt-16 grid gap-5 md:grid-cols-2">
          <Reveal>
            <div className="card h-full text-center">
              <p className="font-display text-6xl tabular-nums text-ember md:text-7xl">
                {val.toLocaleString()}
                <span className="text-ember/70">+</span>
              </p>
              <p className="mt-4 font-display text-lg text-paper">
                local memory engines installed — and counting
              </p>
              <p className="mt-1.5 text-sm text-mute">
                Every one keeps its memories on the user's own machine.
              </p>
            </div>
          </Reveal>
          <Reveal delay={0.08}>
            <div className="card relative h-full overflow-hidden border-ember/30 text-center">
              <div className="absolute inset-0 bg-radial-ember opacity-40" />
              <div className="relative">
                <p className="font-display text-6xl text-paper md:text-7xl">0</p>
                <p className="mt-4 font-display text-lg text-paper">
                  of those memories stored on our servers
                </p>
                <p className="mt-1.5 text-sm text-mute">
                  Not a policy — an architecture. What never leaves cannot leak.
                </p>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
